/* unplugin-vue-components disabled */import { render } from "./SpeedSetting.vue?vue&type=template&id=2d33db06&scoped=true&ts=true"
import script from "./SpeedSetting.vue?vue&type=script&lang=ts"
export * from "./SpeedSetting.vue?vue&type=script&lang=ts"

import "./SpeedSetting.vue?vue&type=style&index=0&id=2d33db06&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d33db06"]])

export default __exports__